exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".StripeElement{margin-right:-11px}@media screen and (max-width: 1080px), screen and (orientation: portrait){.StripeElement{margin-right:-1.7em}}@media screen and (max-width: 1080px) and (max-width: 926px), screen and (orientation: portrait) and (max-width: 926px){.StripeElement{margin-right:-20px}}@media screen and (max-width: 1080px) and (max-width: 768px), screen and (orientation: portrait) and (max-width: 768px){.StripeElement{margin-right:-17px}}@media screen and (max-width: 1080px) and (max-width: 575px), screen and (orientation: portrait) and (max-width: 575px){.StripeElement{margin-right:-15px}}@media screen and (max-width: 1080px) and (max-width: 480px), screen and (orientation: portrait) and (max-width: 480px){.StripeElement{margin-right:-10px}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss","plugins":[null,null]}!./src/components/PaymentSaveCardComponent/style.scss
// module id = 1780
// module chunks = 0